import React, { useRef, useState } from "react";
import { Dimmer } from "../spinner";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";

export const ImprimirTimbresporEntes = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtEntes = useRef();
  const txtEstatus = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtDependencias = useRef();

  const [idente, setIdente] = useState("");
  const [iddepen, setIddepen] = useState("");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");
  const [entes, setEntes] = useState([]);
  const [dependencias, setDependencias] = useState([]);
  const [fechas, setFechas] = useState("");
  const [fechasd, setFechasd] = useState("");
  const [visible, setVisible] = useState(true);

  const [parameterentes, setParameterentes] = useState("");
  const [parameterentesd, setParameterentesd] = useState("");
  const [parameterdepen, setParameterdepen] = useState("");
  const [parameterstatus, setParamaterstatus] = useState("");
  const [parameterstatusd, setParamaterstatusd] = useState("");

  const onChange = (e) => {
    if (e.target.name === "porfecha") {
      if (e.target.checked === true) {
        setVisible(false);
        txtDesde.current.value = moment(fechaSistema).format("YYYY-MM-DD");
        txtHasta.current.value = moment(fechaSistema).format("YYYY-MM-DD");
        setDesde(moment(fechaSistema).format("YYYY-MM-DD"));
        setHasta(moment(fechaSistema).format("YYYY-MM-DD"));
      } else {
        setVisible(true);
        txtDesde.current.value = "";
        txtHasta.current.value = "";
        setDesde("");
        setHasta("");
        setFechas("");
        setFechasd("");
      }
    }

    if (e.target.name === "desde") {
      setDesde(e.target.value);
      setFechas(" and td.fechasolicitud between ");
      setFechasd(" and td.fechaasignado between ");
    } else if (e.target.name === "hasta") {
      setHasta(e.target.value);
      setFechas(" and td.fechasolicitud between ");
      setFechasd(" and td.fechaasignado between ");
    } else if (e.target.name === "estatus") {
      if (e.target.value === "2") {
        setParamaterstatus("and td.status = " + e.target.value);
        setParamaterstatusd("and td.estatustimbre = " + e.target.value);
      } else if (e.target.value === "3") {
        setParamaterstatus("and td.status = " + e.target.value);
        setParamaterstatusd("and td.estatustimbre = " + e.target.value);
      } else if (e.target.value === "4") {
        setParamaterstatus("and td.status = " + e.target.value);
        setParamaterstatusd("and td.estatustimbre = " + e.target.value);
      } else {
        setParamaterstatus("");
        setParamaterstatusd("");
      }
    }

    if (e.target.name === "entes") {
      if (e.target.value !== "") {
        seleccionarRegistrosDependencias(e.target.value);
      } else {
        txtDependencias.current.value = "";
        setDependencias([]);
        setParameterentes("");
        setParameterdepen("");
        setParameterentesd("");
        setIdente("");
      }
    } else if (e.target.name === "dependencias") {
      if (e.target.value !== "") {
        setParameterdepen("and td.iddependencia = ");
      } else {
        setParameterdepen("");
      }
    }
  };

  const onCaptureente = (data) => () => {
    if (data.idente > 0) {
      setIdente(data.idente);
      setParameterentes("and td.idente = ");
      setParameterentesd("and td.usuarioinhabilitado = ");
    } else {
      setIdente(null);
      setParameterentes("");
      setParameterentesd("");
    }
  };

  const blanquear = () => {
    setActivate(false);
    setVisible(true);
    setParamaterstatus("");
    setParameterentesd("");
    setParameterentes("");
    setParameterdepen("");
    setIddepen("");
    setIdente("");
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const cerrarModal = () => {
    if (mensaje.titulo === "Exito.") {
      props.onHideRenderizar();
      props.onHideCancela();
      blanquear();
    }

    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const imprimirReporte = () => {
    let condicion = "";
    let condiciond = "";
    let div3 = "";
    let div1 = "";
    let div2 = "";
    let fechast = "";
    let fechastd = "";
    let reporte = "ReporteTimbresFiscales";

    if (fechas !== "") {
      fechast =
        fechas +
        "'" +
        "||quote_literal(" +
        "'" +
        desde +
        "'" +
        ")||" +
        "'" +
        " and " +
        "'" +
        "||quote_literal(" +
        "'" +
        hasta +
        "'" +
        ")";
      fechastd =
        fechasd +
        "'" +
        "||quote_literal(" +
        "'" +
        desde +
        "'" +
        ")||" +
        "'" +
        " and " +
        "'" +
        "||quote_literal(" +
        "'" +
        hasta +
        "'" +
        ")";
      div3 = " ";
    } else {
      fechast = "";
      fechastd = "";
      div3 = "'";
    }

    let iddepen =
      txtDependencias.current.value === "0"
        ? ""
        : txtDependencias.current.value;

    div1 = " ";

    div2 = " ";

    condicion =
      "'" +
      parameterentes +
      idente +
      div1 +
      parameterdepen +
      iddepen +
      div2 +
      parameterstatus +
      div3 +
      fechast;
    condiciond =
      "'" +
      parameterentesd +
      idente +
      div1 +
      parameterdepen +
      iddepen +
      div2 +
      parameterstatusd +
      div3 +
      fechastd;

    window.open(
      op.reportes +
        "reporte=" +
        reporte +
        "&CONDICION=" +
        condicion +
        "&CONDICIOND=" +
        condiciond,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const seleccionarRegistrosEntes = () => {
    let campos =
      "idtipoente as tipo, trim(nombre) as nombre, idagente as idente";
    let nomtab = "agente";
    let nomid = "ente";

    let endpoint = `${
      op.conexion
    }/api/consulta/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${true}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setEntes(response.data);
          } else {
            setEntes([]);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistrosDependencias = (id) => {
    let campos = "*";
    let nomtab = "dependencias";
    let nomid = "tipoente";

    let endpoint = `${op.conexion}/api/consulta/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setDependencias(response.data);
          } else {
            setDependencias([]);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistrosEntes();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>
          Imprimir Timbres por Entes
        </Modal.Title>
        <button
          ref={btnCancela}
          style={{
            border: 0,
            margin: 0,
            padding: 0,
            color: "#ffffff",
            backgroundColor: "transparent",
          }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <div>
          <div style={{ fontFamily: "Times New Roman, Times, serif" }}>
            <fieldset className=" row col-sm-12 mx-auto border rounded ">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                DATOS:
              </legend>

              <div className="row col-md-12 justify-content-between m-0">
                <div className="col-12 row m-0 px-0">
                  <div className="col-2 py-2 ml-auto">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        onChange={onChange}
                        name="porfecha"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label class="form-check-label" for="flexCheckDefault">
                        POR FECHA
                      </label>
                    </div>
                  </div>
                  <div className="input-group input-group-sm py-2 col-md-3 px-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DESDE:
                    </span>
                    <input
                      type="date"
                      ref={txtDesde}
                      disabled={visible}
                      name="desde"
                      onChange={onChange}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm py-2 col-md-3 px-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      HASTA:
                    </span>
                    <input
                      type="date"
                      ref={txtHasta}
                      disabled={visible}
                      name="hasta"
                      onChange={onChange}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm py-2 col-md-4 px-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      ESTATUS:
                    </span>
                    <select
                      ref={txtEstatus}
                      name="estatus"
                      onChange={onChange}
                      className="form-select form-select-sm"
                    >
                      <option key="01" value="0">
                        TODOS
                      </option>
                      <option key="02" value="2">
                        HABILITADO
                      </option>
                      <option key="03" value="3">
                        INHABILITADO
                      </option>
                      <option key="04" value="4">
                        ANULADO
                      </option>
                    </select>
                  </div>
                </div>

                <div className="col-12 row m-0 px-0">
                  <div className="input-group input-group-sm py-2 col-md-12 px-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      ENTES:
                    </span>
                    <select
                      ref={txtEntes}
                      onChange={onChange}
                      name="entes"
                      className="form-select form-select-sm"
                    >
                      <option key="01" value="">
                        TODOS
                      </option>
                      {entes &&
                        entes.map((a, i) => (
                          <option
                            key={i}
                            onClick={onCaptureente(a)}
                            value={a.tipo}
                          >
                            {a.nombre}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="input-group input-group-sm py-2 col-md-12 px-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DEPENDENCIAS:
                    </span>
                    <select
                      ref={txtDependencias}
                      onChange={onChange}
                      name="dependencias"
                      className="form-select form-select-sm"
                    >
                      <option key="01" value="">
                        TODOS
                      </option>
                      {dependencias &&
                        dependencias.map((b, e) => (
                          <option key={e} value={b.iddependencia}>
                            {b.nombre}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          onClick={imprimirReporte}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> IMPRIMIR</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Mensaje mensaje={mensaje} onHide={cerrarModal} />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/timbres/modalImprimirTimbresEntes.js